"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionTelemetryValidation = void 0;
const ChargingTransactionChargingTelemetryValidation_1 = require("./ChargingTransactionChargingTelemetryValidation");
const ChargingTransactionLowRateChargingTelemetryValidation_1 = require("./ChargingTransactionLowRateChargingTelemetryValidation");
class ChargingTransactionTelemetryValidation {
    static isValid(entity) {
        // Validate entity.charging_transaction_id for existence and correct type.
        if (entity.charging_transaction_id == undefined)
            return false;
        if (typeof entity.charging_transaction_id !== "string")
            return false;
        // If entity.charging_details_telemetry exists, validate that it has the correct type.
        if (entity.charging_details_telemetry != undefined) {
            if (!Array.isArray(entity.charging_details_telemetry))
                return false;
            if (!entity.charging_details_telemetry.every((elem) => {
                if (!ChargingTransactionChargingTelemetryValidation_1.ChargingTransactionChargingTelemetryValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        // If entity.low_rate_charging_details_telemetry exists, validate that it has the correct type.
        if (entity.low_rate_charging_details_telemetry != undefined) {
            if (!Array.isArray(entity.low_rate_charging_details_telemetry))
                return false;
            if (!entity.low_rate_charging_details_telemetry.every((elem) => {
                if (!ChargingTransactionLowRateChargingTelemetryValidation_1.ChargingTransactionLowRateChargingTelemetryValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        return true;
    }
}
exports.ChargingTransactionTelemetryValidation = ChargingTransactionTelemetryValidation;
